<template>
 <div class="app-container">
  <div class="detailsTitle" >
       <h4>字典管理</h4>
    </div>
   <div class="searchBox" ref="searchBox">

    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border  class="tableComent">

        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="90">
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="btnFlg[1]" @click="modifyRegion(scope.row)">维护</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="dictionaryName" min-width="160"  :formatter="emptyFn" label="字典项目"></el-table-column>
        <el-table-column prop="dictionaryType" min-width="160"  :formatter="emptyFn" label="Type"></el-table-column>

       <el-table-column prop="remark" min-width="360" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="createUserName" width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->

 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryMasterList } from '@/api/common-signature'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  components: {

  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新建',
      dialogVisible: false,
      checkList: [],
      tableList: [],

      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        showName: [
          { required: true, message: '请输入流向名称', trigger: 'blur' }
        ]
      },
      addFrom: {},
      flag: true, // 控制组件
      btnFlg: [],
      btnIdArr: ['00FM1D0100', '00FM1D0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/RZdictionaryManagement')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 210) + 'px'
  },
  methods: {
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true

      searchFrom.groupNo = 'ship_flow'
      getDictionaryMasterList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    // 维护
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$router.push({ name: 'RZdictionaryManagementDetails', query: { id: row.masterId, dictionaryName: row.dictionaryName, dictionaryType: row.dictionaryType } })

      // this.$set(this.addFrom, 'showName', row.showName)
      // this.$set(this.addFrom, 'remark', row.remark)
      // this.$set(this.addFrom, 'id', row.id)

      // this.title = '修改'
      // this.dialogVisible = true
      // this.isAdd = false
      // this.flag = true
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
      display: flex;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
  .jiage{
  position: relative;
}
}
.detailsTitle h4{
  font-size: 14px;
  padding: 6px 0;
}

</style>
